module.exports = __webpack_public_path__ + "media/images/icons/paperclip-e818d47c4bbf23210ee15bad04c54b0f.svg";